import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { INewsItem } from 'store/slices/news/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  saveNewsItem,
  loadNewsItem,
  saveNewsItemAsDraft,
} from 'store/slices/news/actions';
import { LangEnum } from 'constants/lang';

import { NewsForm } from './components/NewsForm';
import { mapValuesToForm } from './components/formUtils';

export const AddTranslation: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.news);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadNewsItem(id));
  }, []);

  const onFinish = (values: INewsItem) => {
    setIsLoading(true);
    dispatch(saveNewsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/news');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: INewsItem) => {
    setIsLoading(true);
    dispatch(saveNewsItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/news');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/news');
  };

  // catalog values depends on lang
  const preparedValues = {
    ...item,
    lang: LangEnum.en,
    tags: [],
    tagsData: null,
  };

  return (
    <MainLayout pageTitle='Создание'>
      {item.id && item.id === Number(id) ? (
        <NewsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft
          isLoading={isLoading}
          initialValues={mapValuesToForm(preparedValues)}
        />
      ) : null}
    </MainLayout>
  );
};
